var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex align-center justify-space-between",attrs:{"id":"auth_footer"}},[(!_vm.get_user_details)?_c('router-link',{staticClass:"d-flex align-center text-decoration-none",attrs:{"to":""}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }